import { usePostMutation } from "@/api/swr/useMutation";
import { companyUserCreateSchema } from "@/schema/app/profile/CompanyUser";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof companyUserCreateSchema, z.ZodNull>
>[3];

export const useCreateCompanyUser = (config?: Config) => {
  return usePostMutation(
    companyUserCreateSchema,
    z.null(),
    "/app/company_users",
    config,
  );
};
